var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69107 2.61234L6.52441 2.61266C5.12428 2.61536 4.42421 2.6167 3.88996 2.89022C3.42002 3.13081 3.0383 3.51399 2.79952 3.98486C2.52807 4.52016 2.52942 5.22023 2.53211 6.62035L2.53244 6.78702M6.71995 17.6123L6.55328 17.6126C5.15315 17.6153 4.45309 17.6167 3.91779 17.3452C3.44692 17.1064 3.06373 16.7247 2.82315 16.2548C2.54963 15.7205 2.54828 15.0205 2.54559 13.6203L2.54527 13.4537M17.5324 6.75814L17.5321 6.59148C17.5294 5.19135 17.528 4.49129 17.2545 3.95703C17.0139 3.48709 16.6308 3.10537 16.1599 2.8666C15.6246 2.59514 14.9245 2.59649 13.5244 2.59919L13.3577 2.59951M17.5452 13.4248L17.5456 13.5915C17.5483 14.9916 17.5496 15.6917 17.2782 16.227C17.0394 16.6978 16.6577 17.081 16.1877 17.3216C15.6535 17.5951 14.9534 17.5965 13.5533 17.5992L13.3866 17.5995M2.53885 10.1203L2.54719 10.1203M6.28884 10.1131L6.29718 10.1131M13.7888 10.0987L13.7972 10.0987M10.0388 10.1059L10.0472 10.1059M17.5388 10.0915L17.5472 10.0915",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.20676a1d0c4718a3bb681ec2f48306f2.svg";
export { ForwardRef as ReactComponent };